export const segmentInnitialState = {
  segmentAddData: "",
};
